/**
 * oddit-wishlist.js
 * Swym Wishlist Plus integration for all wishlist heart buttons.
 * Click handler registers immediately (no Swym dependency).
 * Swym API calls are used when available for persistence.
 */
(function () {
  'use strict';

  var WISHLISTED_CLASS = 'is-wishlisted';
  var BTN_SELECTOR = '[data-wishlist-btn]';

  /* Reference to initialized Swym instance — set when ready */
  var swat = null;
  var defaultListId = null;

  /* ------------------------------------------------------------------
     1. Click handler — always active, even before Swym loads
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var isWishlisted = btn.classList.contains(WISHLISTED_CLASS);
    var product = buildProduct(btn);

    /* Toggle visual state immediately for responsiveness */
    btn.classList.toggle(WISHLISTED_CLASS);
    syncMatchingButtons(product.empi, !isWishlisted);

    /* Persist via Swym API if available */
    if (swat && defaultListId) {
      if (isWishlisted) {
        swat.deleteFromList(defaultListId, product, function () {
          showToast('Removed from wishlist');
        }, function () {
          btn.classList.add(WISHLISTED_CLASS);
          syncMatchingButtons(product.empi, true);
          showToast('Could not update wishlist');
        });
      } else {
        swat.addToList(defaultListId, product, function () {
          showToast('Added to wishlist!');
        }, function () {
          btn.classList.remove(WISHLISTED_CLASS);
          syncMatchingButtons(product.empi, false);
          showToast('Could not update wishlist');
        });
      }
    }
  });

  function buildProduct(btn) {
    return {
      empi: Number(btn.getAttribute('data-product-id')),
      epi: Number(btn.getAttribute('data-variant-id')),
      du: window.location.origin + (btn.getAttribute('data-product-url') || ''),
      dt: btn.getAttribute('data-product-title') || '',
      iu: btn.getAttribute('data-product-image') || '',
      pr: Number(btn.getAttribute('data-product-price')) || 0,
    };
  }

  function showToast(message) {
    try {
      if (swat && swat.ui && typeof swat.ui.showSuccessNotification === 'function') {
        swat.ui.showSuccessNotification({ message: message });
      }
    } catch (e) {
      /* Swym notification API unavailable — fail silently */
    }
  }

  /* Sync all buttons for the same product across the page */
  function syncMatchingButtons(empi, wishlisted) {
    document.querySelectorAll(BTN_SELECTOR + '[data-product-id="' + empi + '"]').forEach(function (btn) {
      btn.classList.toggle(WISHLISTED_CLASS, wishlisted);
    });
  }

  /* ------------------------------------------------------------------
     2. PDP variant change — update variant ID on wishlist buttons
     ------------------------------------------------------------------ */
  document.addEventListener('oddit:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('.oddit-section-main-product ' + BTN_SELECTOR).forEach(function (btn) {
      btn.setAttribute('data-variant-id', variant.id);
    });
  });

  /* ------------------------------------------------------------------
     3. Swym initialization — fetch lists + mark existing wishlisted items
     ------------------------------------------------------------------ */
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(function (_swat) {
    swat = _swat;

    /* Bind header wishlist icon to open Swym wishlist UI */
    document.querySelectorAll('a.swym-wishlist').forEach(function (link) {
      link.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (swat.ui && typeof swat.ui.open === 'function') {
          swat.ui.open();
        }
      });
    });

    swat.fetchLists({
      callbackFn: function (lists) {
        if (lists.length > 0) {
          defaultListId = lists[0].lid;
        } else {
          swat.createList({ lname: 'My Wishlist' }, function (newList) {
            defaultListId = newList.lid;
          }, function () {});
        }

        /* Mark buttons that are already wishlisted */
        var wishlistedSet = new Set();
        lists.forEach(function (list) {
          (list.listcontents || []).forEach(function (item) {
            wishlistedSet.add(String(item.empi));
          });
        });

        document.querySelectorAll(BTN_SELECTOR).forEach(function (btn) {
          var productId = btn.getAttribute('data-product-id');
          if (productId && wishlistedSet.has(productId)) {
            btn.classList.add(WISHLISTED_CLASS);
          }
        });
      },
      errorFn: function () {},
    });
  });
})();
